import { render, staticRenderFns } from "./operatingLicense.vue?vue&type=template&id=32bbb53d&scoped=true"
import script from "./operatingLicense.vue?vue&type=script&lang=js"
export * from "./operatingLicense.vue?vue&type=script&lang=js"
import style0 from "./operatingLicense.vue?vue&type=style&index=0&id=32bbb53d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bbb53d",
  null
  
)

export default component.exports